export default __webpack_public_path__ + "static/media/fasting_success_key.9f019810.jpg";